import axios from "./axios"

function search(query) {
    return axios().get("/items-search", {
        params: {
            relations: ["measure_units"],
            search: query
        }
    })
}

export default {
    search
}